export enum MaterialStatusEnum {
  MATCHED = 'MATCHED',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE',
}

export enum MaterialFilterEnum {
  DESCRIPTION = 'description',
  SORT_ASC = 'asc',
  SORT_DESC = 'desc',
}
